import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Card, CardActions, Grid } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import Avatar from '@material-ui/core/Avatar';
import IconButton from '@material-ui/core/IconButton';
import DialogTitle from '@material-ui/core/DialogTitle';
import { Form, FormInput } from '../../core/Formikfy';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Dialog from '@material-ui/core/Dialog';
import Typography from '@material-ui/core/Typography';
import PhotoIcon from '@material-ui/icons/Photo';
import MovieIcon from '@material-ui/icons/Movie';
import Gallery from 'react-photo-gallery';
import { db, storage } from '../../firebase';
import firebase from 'firebase/app';
import LinearProgress from '@material-ui/core/LinearProgress';

const useStyles = makeStyles((theme) => ({
  insideContainer: {
    [theme.breakpoints.up('sm')]: {
      padding: '0 25%',
    },
  },
  large: {
    [theme.breakpoints.down('sm')]: {
      width: theme.spacing(7),
      height: theme.spacing(7),
    },
    [theme.breakpoints.up('sm')]: {
      width: theme.spacing(8),
      height: theme.spacing(8),
    },
  },
  root: {
    borderRadius: 20,
    [theme.breakpoints.up('sm')]: {
      width: '100%',
    },
  },
  label: {
    textTransform: 'capitalize',
    color: '#707070',
    margin: '10px 2px',
  },
  inputCard: {
    [theme.breakpoints.down('sm')]: {
      padding: '20px 5px',
    },
    [theme.breakpoints.up('sm')]: {
      padding: '20px',
    },
  },
  contentContainer: {
    [theme.breakpoints.down('sm')]: {
      margin: '10px 2px',
    },
    [theme.breakpoints.up('sm')]: {
      margin: '10px',
    },
    width: '100%',
  },
  form: {
    width: '100%',
    marginTop: theme.spacing(1),
  },
  input: {
    display: 'none',
  },
  imageList: {
    margin: '10px',
    height: 100,
  },
  video: {
    margin: '20px 0',
    [theme.breakpoints.down('sm')]: {
      height: '200px',
    },
    [theme.breakpoints.up('sm')]: {
      height: '300px',
    },
  },
}));

export const FeedInput = (props) => {
  const classes = useStyles();
  const { profileInfo, currentUser, media } = props;
  const [files, setFiles] = useState<any>([]);
  const [filesRenderInfo, setFilesRenderInfo] = useState<any>([]);
  const [videoRenderInfo, setVideoRenderInfo] = useState<any>([]);
  const [addPostDialogBoxOpen, setAddPostDialogBoxOpen] = useState(false);
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  const [mediaLinks, setMediaLinks] = useState<any>([]);
  const [progress, setProgress] = useState<number>(0);

  const uploadSingleFile = (file, id) => {
    const metadata = {
      contentType: file.type,
    };
    const uploadTask = firebase.storage().ref(`feed-posts/${id}/${file.name}`).put(file, metadata);
    return new Promise((resolve, reject) =>
      uploadTask.on(
        'state_changed',
        (snapshot) => {
          const progress = Math.round((snapshot.bytesTransferred / snapshot.totalBytes) * 100);
          setProgress(progress);
        },
        (error) => {
          reject(error);
          console.log(error);
        },
        () => {
          storage
            .child(`feed-posts/${id}/${file.name}`)
            .getDownloadURL()
            .then((url) => {
              resolve(url);
            });
        }
      )
    );
  };
  const onClickHandler = async (data) => {
    try {
      const doc = await db.collection('feed').add({
        uploader_id: currentUser.uid,
        uploaded_date: firebase.firestore.Timestamp.now(),
        media: {},
        description: data,
        comments: [],
        likes: [],
      });
      const mediaUrls = await Promise.all(files.map((file) => uploadSingleFile(file, doc.id)));
      setMediaLinks(mediaUrls);
      media(mediaUrls);
      const updateFirestore = await db
        .collection('feed')
        .doc(doc.id)
        .update({
          media: { url: mediaUrls[0], type: files[0].type },
        });
    } catch (e) {
      console.error(e);
    }
  };

  const imageFileHandler = (e) => {
    const files = e.target.files;
    if (!files) {
      return;
    }
    const img = new Image();
    img.src = URL.createObjectURL(files[0]);
    img.onload = () => {
      const width = img.naturalWidth;
      const height = img.naturalHeight;
      setFilesRenderInfo( [{ src: img.src, width: width, height: height }]);
    };
    setVideoRenderInfo([])
    setFiles(files[0]);
  };

  const videoFileHandler = (e) => {
    const files = e.target.files;
    if (!files) {
      return;
    }
    const src = URL.createObjectURL(files[0]);
    setVideoRenderInfo([{ src: src }]);
    setFilesRenderInfo( [])
    setFiles(files[0]);
  };

  const addPostDialogBoxHandler = (value) => {
    if (value) {
      setAddPostDialogBoxOpen(true);
    } else {
      setFiles([]);
      setProgress(0);
      setIsButtonDisabled(false);
      setFilesRenderInfo([]);
      setVideoRenderInfo({});
      setAddPostDialogBoxOpen(false);
    }
  };

  if (!profileInfo) {
    return <div></div>;
  }
  return (
    <React.Fragment>
      <Card raised={true} className={classes.inputCard}>
        <Grid container style={{ alignItems: 'center' }}>
          <Grid item sm={2} lg={1}>
            <Avatar src={profileInfo.dp_url} className={classes.large} />
          </Grid>
          <Grid item sm={8} lg={10} style={{ marginLeft: '10px' }}>
            <Button
              classes={{
                label: classes.label,
                root: classes.root,
              }}
              onClick={() => setAddPostDialogBoxOpen(true)}
              variant="outlined"
            >
              What's on your mind?
            </Button>
          </Grid>
        </Grid>
      </Card>
      <Dialog
        fullWidth={true}
        open={addPostDialogBoxOpen}
        onClose={() => addPostDialogBoxHandler(false)}
      >
        <DialogTitle style={{ paddingBottom: '0', textAlign: 'center' }}>Create Post</DialogTitle>
        <Form
          className={classes.form}
          initialValues={{
            description: '',
          }}
          onSubmit={async (data) => {
            setIsButtonDisabled(true);
            await onClickHandler(data.description);
            addPostDialogBoxHandler(false);
          }}
        >
          <DialogContent style={{ padding: '0 20px', display: 'flex', flexDirection: 'column' }}>
            <Gallery photos={filesRenderInfo} />
            {videoRenderInfo.length > 0 && (
              <video className={classes.video} src={videoRenderInfo[0].src} controls />
            )}
            {progress !== 0 && (
              <LinearProgress variant="determinate" value={progress} style={{ margin: '10px' }} />
            )}
            <FormInput
              name="description"
              id="outlined-textarea"
              placeholder={`Whats on your mind ${profileInfo.firstName}?`}
              rows={5}
              multiline
              variant="outlined"
              fullWidth={true}
            />
            <Card elevation={3} style={{ margin: '10px 0px' }}>
              <CardActions>
                <Typography color="textSecondary" style={{ marginRight: 'auto' }}>
                  Add to your post
                </Typography>
                <input
                  accept="video/*"
                  className={classes.input}
                  id="video-upload"
                  type="file"
                  onChange={videoFileHandler}
                />
                <label htmlFor="video-upload">
                  <IconButton
                    color="primary"
                    aria-label="upload video"
                    component="span"
                    style={{ marginLeft: 'auto', paddingRight: '5px' }}
                  >
                    <MovieIcon />
                  </IconButton>
                </label>
                <input
                  accept="image/*"
                  className={classes.input}
                  id="image-upload"
                  type="file"
                  onChange={imageFileHandler}
                />
                <label htmlFor="image-upload">
                  <IconButton
                    color="primary"
                    aria-label="upload picture"
                    component="span"
                    style={{ paddingLeft: '0', paddingRight: '5px' }}
                  >
                    <PhotoIcon />
                  </IconButton>
                </label>
              </CardActions>
            </Card>
          </DialogContent>
          <DialogActions style={{ display: 'block' }}>
            <Button
              onClick={() => addPostDialogBoxHandler(false)}
              color="primary"
              style={{ marginLeft: '10px' }}
            >
              Cancel
            </Button>
            <Button
              type="submit"
              disabled={isButtonDisabled}
              color="primary"
              style={{ marginRight: '10px', float: 'right' }}
            >
              Post
            </Button>
          </DialogActions>
        </Form>
      </Dialog>
    </React.Fragment>
  );
};
